import React from 'react'
import FieldTypes from "./fieldTypes/index.mjs";
import classnames from "classnames";

const _getQuestionComponent = (type) => {
	let component = FieldTypes.hasOwnProperty(type) ? FieldTypes[type] : null;
	if (!component) {
		console.error('Field type not found, using default', type);
		component = 'input';
	}
	return component;
};

const _processRule = ({ rule, dataToUse }) => {
	try {
		let finalRule = rule;
		(Object.keys(dataToUse || {}) || []).forEach(key => {
			const value = dataToUse[key];
			finalRule = finalRule.replaceAll(`{${key}}`, value);
		});
		console.debug('processing rule', {
			originalRule: rule,
			finalRule: finalRule,
		});
		return new Function(`return (${finalRule})`)();
	} catch (ex) {
		console.warn('Unable to process rule', ex.message);
		return false;
	}
}

const FormFieldComponent = ({ className, data, fieldConfig, onFieldChange, value }) => {
	const FieldComponent = _getQuestionComponent(fieldConfig?.type);
	const { className: fieldClassName, shouldHideColon, ...fieldProps } = fieldConfig.props || {};
	const classes = classnames(fieldClassName, className);

	const shouldRenderComponent = () => {
		const fieldRule = fieldConfig?.onlyIfRule;
		return fieldRule ? _processRule({ rule: fieldRule, dataToUse: data}) : true;
	};

	return shouldRenderComponent() && <div className={classes}>
		{ fieldConfig.label && <label>{ fieldConfig.label }{ !shouldHideColon && ":" }</label> }
		<FieldComponent
			{...fieldProps}
			onChange={onFieldChange}
			value={value}
		/>
	</div>;
}

export default FormFieldComponent;

